import React from 'react';

import cs from 'classnames';
import {colors} from 'js-libs/sweetcommons/styles';
import styled, {keyframes} from 'styled-components';

import {gt} from 'app/utils/i18n';

export type ChatMessageType = {
  source: 'me' | 'ai' | 'error';
  text: string;
};

type ChatDisplayType = {
  source: 'me' | 'ai' | 'error';
  text: React.ReactNode;
};

type MessageProps = {
  message: ChatDisplayType;
};
export const ChatMessage = ({message}: MessageProps) => {
  const isUserMessage = message.source === 'me';
  const isErrorMessage = message.source === 'error';

  return (
    <div
      className={cs('d-flex mb-2', {
        'justify-content-end': isUserMessage,
        'align-items-start': !isUserMessage,
        'flex-column': !isUserMessage,
      })}
    >
      {isErrorMessage ? (
        <small className="text-danger">{gt('Error')}</small>
      ) : (
        !isUserMessage && <small className="text-muted">{gt('SweetAI')}</small>
      )}

      <StyledMessageContentDiv
        className={cs('px-2 py-1', {
          'text-danger alert-danger': isErrorMessage,
        })}
        isUserMessage={isUserMessage}
      >
        {message.text}
      </StyledMessageContentDiv>
    </div>
  );
};
const StyledMessageContentDiv = styled.div<{isUserMessage: boolean}>`
  color: ${(props) => (props.isUserMessage ? 'white' : colors.darkGray)};
  background-color: ${(props) =>
    props.isUserMessage ? colors.linkBlue : colors.lightGray};
  border-radius: ${(props) =>
    props.isUserMessage ? '12px 12px 0 12px' : '12px 12px 12px 0'};
  max-width: 75%;
`;

const bounce = keyframes`
  0%, 80%, 1000% {
    opacity: 0.2;
  }
  40% {
    opacity: 0.4;
  }
`;

const Dot = styled.span`
  animation: ${bounce} 1.4s infinite ease-in-out;
  font-size: 0.8em;
  &:nth-child(1) {
    animation-delay: -0.32s;
  }
  &:nth-child(2) {
    animation-delay: -0.16s;
  }
`;

// The main typing indicator component
export const TypingIndicator = () => (
  <div className="d-flex align-items-center text-muted">
    <Dot className="d-inline-block my-0 mr-1">
      <i className="fa fa-circle" />
    </Dot>
    <Dot className="d-inline-block my-0 mr-1">
      <i className="fa fa-circle" />
    </Dot>
    <Dot className="d-inline-block m-0">
      <i className="fa fa-circle" />
    </Dot>
  </div>
);
